import * as api from "@/api/williams/project";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useProjectMetrics(id: string) {
  return useQuery({
    queryKey: queryKeys.project.metrics(id),
    queryFn: () => api.getProjectMetrics(id),
  });
}
